<template>
  <section class="section columns">
    <div class="column container is-four-fifths">
      <h1 class="title is-4">{{project.name}}</h1>
      <div class="has-text-left" v-html="project.content"></div>
      <button class="button" @click.prevent="gotoEStudio(project.id)">Open</button>
    </div>
  </section>
</template>

<script>
import { CourseClient } from "../../clients/CourseClient";
import BaseHelper from "@/helpers/BaseHelper";
export default {
  name: "Project",
  data: function() {
    return {
      project: Object
    };
  },
  props: ["groupId", "userId", "projectId"],
  mixins: [BaseHelper],

  mounted() {
    this.$store.dispatch("loader/show", "Loading project....");
    CourseClient.getProject(this.groupId, this.userId, this.projectId)
      .then(response => {
        this.$store.dispatch("loader/hide");
        this.project = response.data.project;
      })
      .catch(err => {
        console.log(err);
        this.$store.dispatch("loader/hide");
      });
  }
};
</script>

<style lang="scss" scoped>
</style>
